import React from 'react';
import styled from 'styled-components';
import { Contribution, ContributionInvestment } from '../api';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getTotalContributionAmount } from '../ContributionHeaders';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import {
  IconDefinition,
  faCalendar,
  faDollar,
  faEnvelopeCircleCheck,
  faHandHoldingDollar,
} from '@fortawesome/pro-light-svg-icons';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { formattedDateTime } from 'shared/utils/date';
import { investmentStatusLabel } from '../utils';

interface ContributionLeftSideBarProps {
  investmentIndex: number;
  contribution: Contribution;
  investment: ContributionInvestment;
  className?: string;
}

const StyledDiv = styled.div`
  .donation-detail {
    display: flex;
    align-items: center;
    gap: ${SPACERS.tiny};
    margin-bottom: ${SPACERS.tiny};
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

interface Line {
  icon: IconDefinition;
  text: string;
  value: string | number | undefined;
}
const ContributionLeftSideBar: React.FC<ContributionLeftSideBarProps> = ({
  contribution,
  investment,
  className,
}) => {
  const lines: Line[] = [
    {
      icon: faDollar,
      text: 'Amount',
      value: `$${numberWithCommas(
        getTotalContributionAmount(investment).totalContribution,
      )}`,
    },
    {
      icon: faHandHoldingDollar,
      text: 'Status',
      value: investmentStatusLabel(investment.status),
    },
    {
      icon: faCalendar,
      text: 'Created',
      value: formattedDateTime(investment.invitations[0]?.createdAt),
    },
    {
      icon: faEnvelopeCircleCheck,
      text: 'Sent',
      value:
        formattedDateTime(investment.invitations[0]?.createdAt) ||
        'No invitations sent',
    },
  ];
  return (
    <StyledDiv className={className}>
      <TrueImpactText variant="heading-page" className="modal-heading">
        Contribution
      </TrueImpactText>
      <TrueImpactText variant="body-small">
        {lines.map(l => {
          if (l.value === undefined) return null;
          return (
            <TrueImpactText
              key={l.text}
              variant="body-small"
              className="donation-detail"
            >
              <FontAwesomeIcon color={COLORS.ctaPrimary} icon={l.icon} />
              <div>
                <strong>{l.text}</strong>: {l.value}
              </div>
            </TrueImpactText>
          );
        })}
      </TrueImpactText>
    </StyledDiv>
  );
};

export default ContributionLeftSideBar;
